/* tslint:disable */
/* eslint-disable */

export enum ModalInfo {
  TITLE = 'TITLE',
  SUBTITLE = 'SUBTITLE',
  BTNTEXT = 'BTNTEXT'
}

export enum ModalKey {
  STILLWORKING = 'STILLWORKING'
}

export enum GalleryLayout {
  Grid = 'Grid',
  HorizontalScroll = 'HorizontalScroll',
  MasonryHorizontal = 'MasonryHorizontal',
  MasonryVertical = 'MasonryVertical'
}

export enum GroupedBy {
  All_Photos = 'All_Photos',
  Day = 'Day',
  Month = 'Month',
  Year = 'Year'
}

export enum UpdatePasswordPhases {
  AUTHENTICATE,
  REDIRECT_AUTH_LOADING,
  CHANGE_PASSWORD,
  COMPLETE
}

export interface MediaImage {
  width?: number
  size?: number
  height?: number
  url: string
  isLandscape?: boolean | null
}

export interface Media {
  id: string
  title: string
  dateTaken: string | null | undefined
  uploadDate: string
  isVideoType: boolean
  thumbnailImage: MediaImage
  originalImage: MediaImage
  livePhoto?: MediaImage | null
  albumId: string
  username: string
  isBlurred?: boolean
  attributes?: (string | null)[] | null
}

export enum ViewBlocker {
  NONE,
  EMAIL_EXPIRED,
  PASSWORD_EXPIRED
}
